import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import '../css/listadoSaves.css';
import '../css/listadoProducto.css';
import CalificacionBoton from "./CalificacionBoton";
import { getToken } from "../LocalStorage";
import ApiService from "../ApiService";

function ListadoSaves(props: any){
    const navigate = useNavigate();
    const [calificaciones, setCalificaciones]= useState([]);

    console.log('props listado saves:', props);
    
    const limitChars = (data: string, limite: number) => {
        if ( data === null || data === '')
            return data;
        if ( data.length > limite){
            return data.substring(0,limite) + "...";
        }else{
            return data;
        }
    }

    const getMisCalificaciones = () => {
        const token = getToken() || '';
        (new ApiService()).getMisCalificaciones(token).then((data1:any) => {
            console.log(data1);
            setCalificaciones(data1.data?.listado);
        }).catch( err => {

        })
    }

    useEffect(() => {
        getMisCalificaciones();
    },[])


    

    return (<div className="flexColumn" style={{width: '100%'}}>
        {(props.saves?.length > 0)?
            (props.saves?.map( (save: any) => {
                //console.log('save:', save);
                let prod = props.productos.filter((item : any) => item.id === save.idProducto)[0];

                if ( prod == null){
                    return <></>
                }else{
                    return (
                    <div key={"prod_" + prod.id} className="flexRow">
                        <div onClick={() => {
                            navigate("/ndv/producto/" + prod.id);
                        }} className="productoItem2 flexRow" style={{gap: 10, marginBottom: 10,}}>
                            <span className="title">{limitChars(prod.titulo,45)}</span>
                            <img className="img" src={prod.thumbnail} alt={"producto " + prod.id} />
                            <span className="precio">${Math.round(prod.precio)}</span>
                        </div>
                        <div>
                            <CalificacionBoton idProducto={prod?.id} productos={props.productos} save={save} calificaciones={calificaciones}
                                onClick={(save1: any ) => {
                                    //console.log("Calificar producto: ", save1);
                                    navigate("/ndv/calificar/" + save1.id);
                                }}
                            />
                        </div>
                    </div>)
                }
                
                
            }))
        :null
        }
    </div>)
}

export default ListadoSaves;